export default function makeTag(tagName, source) {
  const tag = document.createElement(tagName);
  tag.setAttribute('src', source);

  return tag;
}
